import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import { useEffect, useState } from "react";
import ApiDatabase from "../server";
import { Building, Warning } from "../assets/icons";
import { formatTimeDifference } from "../utils/Date";
import StyledInput from "../components/styledInput/StyledInput";
import useTitle from "../hooks/TitleManager";
import UseContext from "../hooks/useContext";

const SettingsCompanies = () => {
  useTitle({ title: "Paramètres - Établissements" });
  const { companies, setCompanies } = UseContext();
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    setIsWaiting(true);
    ApiDatabase.getCompaniesInfosEmployees(
      {},
      (data) => {
        setCompanies(data.companies);
        setIsWaiting(false);
      },
      (err) => {
        setIsWaiting(false);
        console.log(err);
      },
    );
  }, [setCompanies]);

  const updateEmployeesList = (companyId, updatedEmployees) => {
    const updatedCompanies = companies.map((company) =>
      company._id === companyId
        ? {
            ...company,
            employees: company.employees?.map((employee) => {
              const updatedEmployee = updatedEmployees.find(
                (updatedEmployee) => updatedEmployee.value === employee._id,
              );

              return updatedEmployee
                ? { ...employee, checked: updatedEmployee.checked }
                : employee;
            }),
          }
        : company,
    );
    setCompanies(updatedCompanies);

    ApiDatabase.putCompaniesInfosEmployees(
      {
        idCompany: companyId,
        employees: updatedCompanies
          .find((company) => company._id === companyId)
          .employees.map((employee) => {
            return {
              idUser: employee._id,
              checked: employee.checked,
            };
          }),
      },
      (data) => {
        // console.log(data);
      },
      (err) => {
        // console.log(err);
      },
    );
  };

  return (
    <PageContainer type={"organization_settings_companies"}>
      <SettingsLayout>
        <div className="flex flex-col gap-6">
          <h1 className="ft-xl font-semibold text-gray-900 pl-4">
            Établissements
          </h1>
          <div className={"flex flex-col gap-4"}>
            {isWaiting ? (
              <>
                {[1, 2, 3, 4].map((item, index) => (
                  <div
                    key={index}
                    className={
                      "flex w-full animate-pulse items-center justify-between gap-4 rounded-lg border px-4 py-3"
                    }
                  >
                    <div className={"flex items-center gap-2"}>
                      <div className={"h-10 w-10 rounded bg-gray-200"}></div>
                      <div className={"flex flex-col gap-1"}>
                        <div className={"h-4 w-20 rounded bg-gray-200"}></div>
                        <div className={"h-4 w-60 rounded bg-gray-200"}></div>
                      </div>
                    </div>
                    <div className={"flex w-full min-w-0 max-w-[140px] shrink-0"}>
                      <div className={"h-12 w-full rounded bg-gray-200"}></div>
                    </div>
                  </div>
                ))}
              </>
            ) : companies.length > 0 ? (
              companies.map((company, index) => (
                <div
                  key={index}
                  className={
                    "flex w-full items-center justify-between gap-4 rounded-lg border px-4 py-3"
                  }
                >
                  <div className={"flex items-center gap-2"}>
                    <div
                      className={
                        "flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-600"
                      }
                    >
                      <Building wh={20} color={"#374151"} />
                    </div>
                    <div className={"flex flex-col"}>
                      {company.companyName}
                      {company.lastSyncDate ? (
                        <div className={"ft-sm text-gray-500"}>
                          Dernière synchronisation : il y a{" "}
                          {formatTimeDifference(
                            new Date(
                              new Date().getTime() -
                                new Date(company.lastSyncDate).getTime(),
                            ),
                          )}
                          {company.badgerName ? ` (${company.badgerName})` : ""}
                        </div>
                      ) : (
                        <div
                          className={
                            "ft-sm flex items-center gap-1 text-red-500"
                          }
                        >
                          <Warning wh={20} color={"#EF4444"} />
                          Badgeuse non connectée
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={"flex w-full min-w-0 max-w-[140px] shrink-0"}>
                    <StyledInput
                      type={"selectMultipleCheckbox"}
                      value={`${company.employees?.filter((employee) => employee.checked).length} ${company.employees?.filter((employee) => employee.checked).length === 1 ? "employé" : "employés"}`}
                      list={company.employees?.map((employee) => {
                        return {
                          value: employee._id,
                          label: employee.firstname + " " + employee.lastname,
                          checked: employee.checked,
                        };
                      })}
                      onChange={(updatedEmployees) =>
                        updateEmployeesList(company._id, updatedEmployees)
                      }
                    />
                  </div>
                </div>
              ))
            ) : (
              <div className={"ft-lg text-gray-500"}>Aucun établissement</div>
            )}
          </div>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsCompanies;
